import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Result } from '@digibricks/core';
export var SpeakingAnswerValue = /*#__PURE__*/function () {
  function SpeakingAnswerValue(props) {
    _classCallCheck(this, SpeakingAnswerValue);

    _defineProperty(this, "props", void 0);

    this.props = props;
  }

  _createClass(SpeakingAnswerValue, [{
    key: "audioFile",
    get: function get() {
      return this.props.audioFile;
    }
  }, {
    key: "responseTime",
    get: function get() {
      return this.props.responseTime;
    }
  }], [{
    key: "create",
    value: function create(props) {
      if (!props.audioFile) {
        return Result.fail('Audio file is required');
      }

      return Result.ok(new SpeakingAnswerValue(props));
    }
  }]);

  return SpeakingAnswerValue;
}();